import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ApiService } from 'src/app/services/api-service/api.service';
import { CreateUserComponent } from '../create-user/create-user.component';
import { Router } from '@angular/router';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { ErrorService } from 'src/app/services/error/error.service';
import { AlertService } from '@full-fledged/alerts';

@Component({
  selector: 'app-parking-agents',
  templateUrl: './parking-agents.component.html',
  styleUrls: ['./parking-agents.component.css']
})
export class ParkingAgentsComponent {

  constructor(
    private apiService: ApiService,
    private dialogRef: MatDialog,
    private router: Router,
    public dialog: MatDialog,
    private errorService: ErrorService,
    private alertService: AlertService,
  ) { }

  isLoading = true;
  search = '';
  parkingAgentsData: any = [];
  dtOptions: DataTables.Settings = {};
  currentSortParam = '';

  ngOnInit(): void {
    this.dtOptions = {
      pagingType: 'full',
      ordering: true,
      processing: true,
      serverSide: true,
      searching: true,
      search: true,
      columns: [{
        title: 'Nume',
        data: 'firstName'
      },
      {
        title: 'Prenume',
        data: 'lastName'
      },
      {
        title: 'E-mail',
        data: 'email'
      },
      {
        title: 'Numărul de bilete scanate astăzi',
        data: 'ticketsScanned'
      },
      {
        title: 'Numărul de amenzi date astăzi',
        data: 'finesIssued'
      },
      {
        title: 'Acțiuni',
        render: function (data, type, row) {
          return `<button class="btn btn-sm btn-square btn-neutral text-danger-hover btn-delete-agent" data-id="${row.id}"><i class="bi bi-trash"></i></button>`;
        },
        orderable: false
      }
      ],
      ajax: (data: any, callback, settings) => {
        this.isLoading = true;
        this.apiService.getAllParkingAgents(data.search.value, data.length, data.start, this.currentSortParam).subscribe(
          (response: any) => {
            this.parkingAgentsData = response.results.map((row: any) => {
              return {
                firstName: row.firstName || '-',
                lastName: row.lastName || '-',
                email: row.email || '-',
                ticketsScanned: row.stats.ticketsScanned || '-',
                finesIssued: row.stats.finesIssued || '-',
                id: row.id
              }
            });

            setTimeout(() => {
              callback({
                draw: data.draw,
                data: this.parkingAgentsData,
                recordsTotal: response.total,
                recordsFiltered: response.total
              });
            }, 50);
          },
          (error: any) => {
            console.error('API Error:', error);
            this.isLoading = false;
          },
        );

      },

      language: {
        search: "_INPUT_",
        searchPlaceholder: "Search",
        paginate: {
          first: '<<',
          previous: '<',
          next: '>',
          last: '>>'
        }
      },
    };
  }

  openDialog() {
    this.dialogRef.open(CreateUserComponent);
  }

  deleteAgent(agentId: string): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
    });

    dialogRef.componentInstance.message = 'Ești sigur că vrei să ștergi acest cont?'
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.apiService.deleteAgent(agentId)
          .subscribe({
            next: (res) => {
              this.alertService.success('Item deleted successfully');
              this.router.navigateByUrl(this.router.url, { skipLocationChange: true }).then(() => {
                // Reload the DataTables data
                const table = $('table[datatable]').DataTable();
                table.ajax.reload(() => { }, false);
              });
            },
            error: err => {
              this.errorService.showError(err);
            }
          });
      }
    });
  }

  ngAfterViewInit(): void {
    $(document).on("click", ".btn-delete-agent", (event) => {
      const agentId = $(event.currentTarget).data("id");
      this.deleteAgent(agentId);
    });
  }

  sortTable(columnName: string) {
    this.currentSortParam = this.currentSortParam === `${columnName}|asc` ? `${columnName}|desc` : `${columnName}|asc`;
  }

}
